import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { projects } from "@/mocks/projects";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FloatingSocial from "@/components/feature/FloatingSocial";
import ProjectHero from "./components/ProjectHero";
import ProjectInfo from "./components/ProjectInfo";
import ProjectGallery from "./components/ProjectGallery";
import RelatedProjects from "./components/RelatedProjects";

export default function ProjectDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const project = projects.find((p) => p.id === Number(id));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  if (!project) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8F9FA]">
        <div className="text-center px-6">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#4CAF50]/10 mx-auto mb-4">
            <i className="ri-error-warning-line text-[#4CAF50] text-2xl" />
          </div>
          <h2 className="text-2xl font-bold text-[#1A2B4A] mb-2">Proje Bulunamadı</h2>
          <p className="text-[#718096] text-sm mb-6">
            Aradığınız proje mevcut değil veya kaldırılmış olabilir.
          </p>
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-2 bg-[#4CAF50] text-white text-sm font-semibold px-6 py-2.5 rounded-full hover:bg-[#388E3C] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-line" />
            Ana Sayfaya Dön
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white page-fade">
      <Navbar />
      <FloatingSocial />

      <main>
        <ProjectHero project={project} />
        <ProjectInfo project={project} />
        <ProjectGallery project={project} />
        <RelatedProjects currentProject={project} />

        {/* CTA Strip */}
        <section className="bg-[#1A2B4A] py-14 px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
              Projeniz mi var?
            </h3>
            <p className="text-white/60 text-sm mb-7">
              Güvenli Dizayn olarak her ölçekte projeye hazırız. Ücretsiz keşif ve teklif için hemen iletişime geçin.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://wa.me/905321367981"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#25D366] text-white text-sm font-semibold px-7 py-3 rounded-full hover:bg-[#1ebe5d] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-base" />
                WhatsApp ile Yaz
              </a>
              <a
                href="tel:+905321367981"
                className="flex items-center gap-2 border-2 border-[#4CAF50] text-[#4CAF50] text-sm font-semibold px-7 py-3 rounded-full hover:bg-[#4CAF50] hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-base" />
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
